import type { DialogueVideoMessage } from 'components/Dialogue/types';
import { VideoMessage } from 'components/Dialogue';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';
import QuoteMessage from '../QuoteMessage';
import { useChatContext } from '../../contexts/ChatContext';
import { memo } from 'react';

export const VideoMsg = memo((props: BaseMsgProps) => {
  const { raw, msg, conversation } = props;
  const { dialogRef, clickQuote } = useChatContext();
  const data =
    raw.channel === 'KWAI'
      ? {
          ...(msg as DialogueVideoMessage).content,
          url: raw.videoContent?.localVideoUrl || (msg as DialogueVideoMessage).content.url,
        }
      : (msg as DialogueVideoMessage).content;
  const { topBarInfo } = conversation;

  return (
    <MessageExtendComplex
      {...props}
      content={
        <QuoteMessage
          message={raw}
          storeName={topBarInfo?.storeName}
          wrap
          onQuoteClick={clickQuote}
        >
          <VideoMessage
            dataSource={data}
            msg={msg.raw}
            storeName={topBarInfo?.storeName}
            lazyScrollContainer={dialogRef?.dom}
          />
        </QuoteMessage>
      }
    />
  );
});
